import React from 'react'
import {useFiltersForm} from 'hooks/useFiltersForm'
import {FilterUrlParams} from 'modules/search/types'

import {Box} from '@vio/atlas/helpers/Box'

import {RecentlyUsedFilter} from '../utils'
import {StoredFilterItem} from './StoredFilterItem'

export interface RecentlyUsedFiltersProps
  extends Pick<
    ReturnType<typeof useFiltersForm>,
    'toggleMultiFilter' | 'toggleFilters'
  > {
  storedFilters: RecentlyUsedFilter[]
  filters: FilterUrlParams
  appliedFilters: FilterUrlParams
}

const RecentlyUsedFiltersComponent = ({
  storedFilters,
  ...props
}: RecentlyUsedFiltersProps) => {
  return (
    <Box display="flex" gap="s300" flexWrap="wrap">
      {storedFilters.map(({value, type, id}) => (
        <StoredFilterItem key={id} filterValue={value} type={type} {...props} />
      ))}
    </Box>
  )
}

export const RecentlyUsedFilters = React.memo(RecentlyUsedFiltersComponent)
